import { useNavigate } from "react-router-dom";
import FoldedPopup from "../../FoldedPopup/FoldedPopup";
import CTAButton from "../../CTAButton/CTAButton";
import { useState } from "react";

export default function CrunchTimePopup(props) {
  const [crunchTimePopupEnabled, setCrunchTimePopupEnabled] = useState(true);
  console.log("crunch time popup renedered");
  console.log("enabled? " + crunchTimePopupEnabled);
  return (
    <FoldedPopup
      noImage={true}
      closeButton={true}
      enabled={crunchTimePopupEnabled}
      setEnabled={setCrunchTimePopupEnabled}
      className="crunch-time-popup"
      width={"500px"}
    >
      <h1>{props.user.name + ", it's Crunch Time!"}</h1>
      <p
        style={{
          fontWeight: 500,
        }}
      >
        Your Test Date is coming up! We've accelerated your study speed to make
        sure that you know all the terms for this set.
      </p>
      <CTAButton
        text="Got it!"
        color="purple"
        onClick={() => {
          setCrunchTimePopupEnabled(false);
        }}
      ></CTAButton>
    </FoldedPopup>
  );
}
